/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var getInfo = function () { /* empty */ };

/*eslint-disable*/
// do not add to package.json
require('magcore-plugin-youtube-dl').onAppInit({}, function ( error , plugin ){
    getInfo = plugin.getInfo;
});

module.exports = function ( config, callback ) {

    if ( config && config.url ) {
        getInfo(config.url, function ( error, information ) {
            var bestFormat, i, size;

            for ( i = 0, size = information.formats.length; i < size; ++i ) {
                information.formats[i].resolution = information.formats[i].resolution || '';
                if ( information.formats[i].container === 'mp4' && information.formats[i].audioBitrate ) {
                    if ( bestFormat ) {
                        if ( bestFormat.resolution < information.formats[i].resolution && information.formats[i].type.indexOf('video') !== -1 ) {
                            bestFormat = information.formats[i];
                        }
                    } else if ( information.formats[i].type.indexOf('video') !== -1 ) {
                        bestFormat = information.formats[i];
                    }
                }
            }

            if ( bestFormat && bestFormat.url && callback ) {
                callback(false, {url: bestFormat.url});
            } else if ( callback ) {
                callback(true);
            }
        });
    } else if ( callback ) {
        callback(true);
    }
};
